import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=070bbbeb&scoped=true&"
import script from "./Puzzle.vue?vue&type=script&lang=ts&"
export * from "./Puzzle.vue?vue&type=script&lang=ts&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&id=070bbbeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bbbeb",
  null
  
)

export default component.exports